export default __webpack_public_path__ + "static/media/m-fsk-06.98efcdaa.jpg";